// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__15mJ7","paramInput":"JobSimulator_paramInput__2Tof1","input":"JobSimulator_input__3UDoX"};